import Stack from "../services/contentstack";

export const getHeaderRes = async (entryUrl, referenceFieldPath, jsonRtePath) => {
    const response = await Stack.getEntryByUrl({
      contentTypeUid: 'header',
      entryUrl,
      referenceFieldPath: referenceFieldPath || [],
      jsonRtePath: jsonRtePath || [],
    });
    // liveEdit && addEditableTags(response[0], 'page', true);
    return response[0];
  };